module.exports = __webpack_public_path__ + "43e0e584121c5f465b194560d4a490d2.MP3";